module.exports = __webpack_public_path__ + "static/img/construction-equipment.4776121.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/construction-equipment.jpeg
// module id = 1687
// module chunks = 5